import IssueReportFields from '@/views/backstage/structure/system_management_page/issue_report_page/common/IssueReportPageFields'

let issue_structure = {
  name: '編輯',
  type: 'group',
  fields: [].concat(
    IssueReportFields['status'],
    IssueReportFields['type'],
    IssueReportFields['username'],
    IssueReportFields['created_time'],
    IssueReportFields['screenshot_url'],
    IssueReportFields['content'],
    IssueReportFields['reply_content'],
  )
}

export default () => {
  return issue_structure
}